import { useAuthStore } from '../../stores/authStore.js';
import { toast } from 'sonner';
import { t } from 'i18next';

export function hasWritePermission() {
  const flags = useAuthStore.getState().currentUser?.info?.user_flags;

  if (flags && flags.includes('observer')) {
    toast.error(t('observer_no_write_permission'));
    return false;
  }
  return true;
}
